import { useEffect }  from 'react';

export const useLoginStateBannerLoaders = (
    setLoginStateChangeInProgress,
    bannersList,
) => {
    // handle state when login/logout is in progress
    useEffect(() => {
        // set login in progress state until new banners will come in store
        const loginChangeHandler = () => (setLoginStateChangeInProgress(true));
        document.addEventListener('justLoggedIn', loginChangeHandler);
        document.addEventListener('justLoggedOut', loginChangeHandler);

        return () => {
            document.removeEventListener('justLoggedIn', loginChangeHandler);
            document.removeEventListener('justLoggedOut', loginChangeHandler);
        };
    }, []);

    // reset login change progress if banners were updated
    useEffect(() => {
        setLoginStateChangeInProgress(false);
    }, [bannersList]);
};
